import { StatisticalAnalysisHeaderNavigationItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-header/statistical-analysis-header.models'
import { initialStatisticalInfoPaginatorState, StatisticalInfoPaginatorState, StatisticalInfoPaginatorTrackingItems } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-info-paginator/statistical-analysis-info-paginator.model'
import { StatisticsAnalysisGeneralStatisticsTrackingItems } from '@/modules/statistical-analysis-module/views/general-statistics-dossier/general-statistics-dossier.model'
import { Nullable } from '@/shared/types/app.types'
import { findIndex, isNil } from 'lodash'
import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class StatisticalInfoPaginator extends Vue {
    @Prop() readonly trackingItems!: StatisticalInfoPaginatorTrackingItems[]
    @Prop() readonly trackingItem!: StatisticalInfoPaginatorTrackingItems
    @Prop() readonly totalTracking!: Nullable<StatisticalAnalysisHeaderNavigationItems<number>>
    @Watch('trackingItem', { immediate: true })
    ontrackingItemChanged(selected: StatisticsAnalysisGeneralStatisticsTrackingItems) {
        const indexSelected = findIndex(this.trackingItems, ['key', this.trackingItem.key])
        this.state = {
            ...this.state,
            indexSelected,
            selected
        }
    }
    @Emit()
    backView(): boolean {
        return true
    }
    @Emit()
    changeTrackItem(value: StatisticalInfoPaginatorTrackingItems): StatisticalInfoPaginatorTrackingItems {
        return value
    }

    state: StatisticalInfoPaginatorState
    constructor() {
        super()
        this.state = initialStatisticalInfoPaginatorState()
    }

    created() {
        this.$eventHub.$on('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-loading', this._onStatisticalLoadingGridTable)
    }

    get isExternalLoading(): boolean {
        return this.state.externalLoading
    }

    get showTotalsOf(): boolean {
        return !isNil(this.trackingItem.value)
    }

    get totalTrackingItems(): number {
        return this.totalTracking ? this.totalTracking.value : this.trackingItems?.[0].value!
    }

    get nameTrackingItem(): string {
        return this.state.selected?.label!
    }

    get valueTrackingItem(): number {
        return this.state.selected?.value!
    }

    get canNext(): boolean {
        return this.state.indexSelected < this.trackingItems.length - 1
    }

    get canBack(): boolean {
        return this.state.indexSelected > 0
    }

    onBackToGeneralView(): void {
        this.backView()
    }

    nextTrackItem(): void {
        this.state.indexSelected++
        this.state.selected = this.trackingItems[this.state.indexSelected]
        this.changeTrackItem(this.state.selected)
    }

    backTrackItem(): void {
        this.state.indexSelected--
        this.state.selected = this.trackingItems[this.state.indexSelected]
        this.changeTrackItem(this.state.selected)
    }

    private _onStatisticalLoadingGridTable(value: boolean): void {
        this.state.externalLoading = value
    }
}
